import { combineReducers } from 'redux';
import mainReducer from "./mainReducer";
import uiReducer from './uiReducer';
import statsReducer from "./statsReducer";
import agentsReducer from "./agentsReducer";
import funnelsReducer from './funnelsReducer';
import automaticAnswersReducer from './automaticAnswersReducer';
import retailerUsersReducer from './retailerUsersReducer';
import customersReducer from './customersReducer';
import productsReducer from './productsReducer';
import customerListReducer from './customerListReducer';
import ordersReducer from './ordersReducer';
import digitalPaymentsReducer from './digitalPaymentsReducer';
import fastAnswersReducer from './fastAnswersReducer';
import chatbotsReducer from './chatbotsReducer';
import wsTemplatesReducer from './wsTemplatesReducer';
import customFieldsReducer from "./customFieldsReducer";
import dealsReducer from './dealsReducer';
import tagsReducer from './tagsReducer';
import chatsReducer from './chatsReducer';
import commentsReducer from './commentsReducer';
import staffReducer from './staffReducer';
import salesChannelsReducer from './salesChannelsReducer';
import customerEventsReducer from './customerEventsReducer';
import messagesReducer from './messagesReducer';
import rolesReducer from './rolesReducer';
import guidesReducer from './guidesReducer';
import inventoriesReducer from './inventoriesReducers';
import conversationTopics from './conversationTopics';
import sidebarReducer from './sidebarReducer';
import academyReducer from './academyReducer';
import messageRemindersReducer from './messageRemindersReducer';
import createCampaignReducer from './createCampaignReducer';
import customerReducer from './customerReducer';
import conversationsReducer from './inbox/conversationsReducer';
import conversationMessagesReducer from './inbox/conversationMessagesReducer';
import inboxAgentsReducer from './inbox/inboxAgentsReducer';
import contactGroupsReducer from './contactGroupsReducer';
import inboxTeamsReducer from './inbox/inboxTeamsReducer';
import unreadChatsReducer from './inbox/unreadChatsReducer';
import platformRetailersStatusReducer from './inbox/platformRetailersStatusReducer';
import inboxRightReducer from './inbox/inboxRightReducer';
import teamReducer from './teamReducer';
import wsCallSidebarReducer from './wsCallSidebarReducer';
import outboundFollowUpsReducer from './outboundFollowUpsReducer';
import voiceReducer from './voice/voiceReducer';
import voiceLiveCallsReducer from './voice/voiceLiveCallsReducer';

const appReducer = combineReducers({
  mainReducer,
  statsReducer,
  agentsReducer,
  funnelsReducer,
  automaticAnswersReducer,
  retailerUsersReducer,
  customersReducer,
  productsReducer,
  customerListReducer,
  ordersReducer,
  customFieldsReducer,
  digitalPaymentsReducer,
  fastAnswersReducer,
  chatbotsReducer,
  wsTemplatesReducer,
  dealsReducer,
  tagsReducer,
  chatsReducer,
  commentsReducer,
  staffReducer,
  salesChannelsReducer,
  customerEventsReducer,
  messagesReducer,
  rolesReducer,
  guidesReducer,
  inventoriesReducer,
  conversationTopics,
  sidebarReducer,
  academyReducer,
  messageRemindersReducer,
  createCampaignReducer,
  customerReducer,
  teamReducer,
  wsCallSidebarReducer,
  uiReducer,
  voiceReducer,
  voiceLiveCallsReducer,
  conversationsReducer,
  conversationMessagesReducer,
  inboxAgentsReducer,
  contactGroupsReducer,
  inboxTeamsReducer,
  unreadChatsReducer,
  platformRetailersStatusReducer,
  inboxRightReducer,
  outboundFollowUpsReducer
});

/**
 * Root reducer that combines all the application reducers and handles
 * the store reset action.
 *
 * If it receives an action of type `RESET_STORE`, it resets the state to `undefined`,
 * causing all reducers to revert to their initial state.
 *
 * @param {Object} state - The current Redux store state.
 * @param {Object} action - The action being dispatched.
 * @returns {Object} The new Redux store state.
 *
 * @example
 * const newState = rootReducer(currentState, action);
 */
const rootReducer = (state, action) => {
  if (action.type === 'RESET_TEMPORAL_STATE') {
    const partialMainReducer = { currentRetailerUser: state.mainReducer?.currentRetailerUser };
    return appReducer({
      mainReducer: partialMainReducer,
      retailerUsersReducer: state.retailerUsersReducer,
      uiReducer: state.uiReducer,
      // Keep live call session across in-app navigation (many screens reset temporal state).
      voiceReducer: state.voiceReducer,
      voiceLiveCallsReducer: state.voiceLiveCallsReducer,
      wsCallSidebarReducer: state.wsCallSidebarReducer
    }, action);
  }

  if (action.type === 'RESET_STORE') {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
